import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { WhatsNewDialog } from '@/components/WhatsNewDialog';

export function AppShell({ children }) {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 p-4 md:p-6">
          <div className="mx-auto w-full max-w-[1280px]">
            {children}
          </div>
        </main>
      </div>
      <WhatsNewDialog />
    </div>
  );
}
